import request from "@/plugins/axios";
import {getList, getOne, getRawResult} from "@/util/dbHelper";
import {deleteGameInstance} from "@/api/instance";

export function updateGame(game){
  const availableKey = ['name','players']
  const instance = {...game}
  const update = Object.entries(instance)
  .filter(([key,value])=> (value || value === 0) && availableKey.includes(key))
  .map(([key,value])=> `\`${key}\` = '${typeof value === 'object' ? JSON.stringify(value) : value}'`)
  const query = `
UPDATE game
SET
    ${update.join(',')},
    id = id
WHERE id = ${game.id}
`
  return request.post('/dbManager?updateGame',{query})
}

export function createGame(game){
  const query = `INSERT INTO game (
    name
  ) VALUES (
    '${game.name}'
  )`
  return request.post(`/dbManager?createGame`, {query}).then(getRawResult)
}
export function getGame(id){
  const query = `SELECT * FROM game WHERE id = ${id}`
  return request.post('/dbManager?getGame',{query}).then(getOne)
}

export function getGames(){
  const query = 'SELECT * FROM game ORDER BY id desc'
  return request.post('/dbManager?getGames',{query}).then(getList)
}
export async function deleteGame(gameId){
  const query = `DELETE FROM game WHERE id = ${gameId}`
  await deleteGameInstance(gameId)
  return await request.post('/dbManager?deleteGame',{query}).then(getRawResult)
}